import { RouteRecordRaw } from 'vue-router';
import { meta, route } from '@/router/router-helpers.ts';

const CharterAuditLogsView = () => import('@/Features/Charter/views/CharterAuditLogs.vue');
const CharterCrewBriefingView = () => import('@/Features/Charter/views/CharterCrewBriefingView.vue');
const CharterCrewBriefingFormView = () => import('@/Features/Charter/views/CharterCrewBriefingFormView.vue');
const CharterDailyDeparturesView = () => import('@/Features/Charter/views/CharterDailyDepartures.vue');
const CharterFinancialReportView = () => import('@/Features/Charter/views/CharterFinancialView.vue');
const CharterChangesView = () => import('@/Features/Charter/views/CharterFlightChanges.vue');
const CharterFlightsOverviewView = () => import('@/Features/Charter/views/CharterFlightsOverview.vue');
const CharterIndexView = () => import('@/Features/Charter/views/CharterIndexView.vue');
const CharterMasterDataView = () => import('@/Features/Charter/views/CharterMasterDataView.vue');
const CharterUsersView = () => import('@/Features/Charter/views/CharterUsersView.vue');

const CHARTER_APP_ID = 'charter' as const;
const charterMeta = (title: string) => meta({
  app: CHARTER_APP_ID,
  charterAccessRequired: true,
  title,
});

const charterRoutes: RouteRecordRaw[] = [
  route('charter', CharterIndexView, {
    path: '/charter',
    meta: charterMeta('Charter'),
    redirect: { name: 'charter-flights-overview' },
    children: [
      route('charter-flights-overview', CharterFlightsOverviewView, {
        path: 'flights-overview',
        meta: charterMeta('Flights Overview'),
      }),
      route('charter-flight-crew-briefing', CharterCrewBriefingFormView, {
        path: 'flights-overview/:charterId/crew-briefing',
        meta: charterMeta('Crew Briefing'),
      }),
      route('charter-changes', CharterChangesView, {
        path: 'changes',
        meta: charterMeta('Changes'),
      }),
      route('charter-daily-departures', CharterDailyDeparturesView, {
        path: 'daily-departures',
        meta: charterMeta('Daily Departures'),
      }),
      route('charter-audit-logs', CharterAuditLogsView, {
        path: 'audit-logs',
        meta: charterMeta('Audit Logs'),
      }),
      route('charter-crew-briefing', CharterCrewBriefingView, {
        path: 'crew-briefing',
        meta: charterMeta('Crew Briefing'),
      }),
      route('charter-master-data', CharterMasterDataView, {
        path: 'master-data',
        meta: charterMeta('Master Data'),
      }),
      route('charter-users', CharterUsersView, {
        path: 'users',
        meta: charterMeta('Users'),
      }),
      route('charter-financial-report', CharterFinancialReportView, {
        path: 'financial-report',
        meta: charterMeta('Financial Report'),
      }),
    ],
  }),
];

export default charterRoutes;
